import { action, observable, runInAction, toJS } from "mobx";

class store {
    @observable data = [];

    @observable onChange = (name, value) => {

    }
}


const summery = new store();

export default summery;


// WEBPACK FOOTER //
// ./src/store/charter/summary.js